<template>
  <section class="section pt-3">
    <div class="buttons is-pulled-right" v-show="current_human_task_uuid">
      <button
        class="button is-primary is-rounded"
        @click="execute"
        :disabled="!current_human_task_uuid"
      >
        <span class="icon">
          <i class="fa fa-bolt"></i>
        </span>
        <span>{{ $t("execute") }}</span>
      </button>
      <button
        class="button is-info is-rounded"
        @click="save"
        :disabled="!current_human_task_uuid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button
        class="button is-danger is-rounded"
        @click="remove"
        :disabled="!current_human_task_uuid"
      >
        <span class="icon">
          <i class="fa fa-trash"></i>
        </span>
        <span>{{ $t("delete") }}</span>
      </button>
    </div>
    <div class="buttons">
      <div class="button is-warning is-rounded" @click="refresh">
        <span class="icon">
          <i class="fa fa-refresh"></i>
        </span>
        <span>{{ $t("refresh") }}</span>
      </div>
      <div
        class="button is-info is-rounded"
        @click="
          $router.push({ path: `/ngine/composer/process/${$route.params.id}` })
        "
      >
        <span class="icon">
          <i class="fa fa-arrow-left"></i>
        </span>
        <span>{{ $t("back") }}</span>
      </div>
      <div class="button is-primary is-rounded" @click="new_human_task">
        <span class="icon">
          <i class="fa fa-plus"></i>
        </span>
        <span>{{ $t("new") }}</span>
      </div>
    </div>

    <div class="columns mt-5">
      <div class="column is-3">
        <aside class="menu">
          <ul class="menu-list">
            <li>
              <div class="field">
                <label class="label">{{ $t("filter") }}</label>
                <input class="input" type="text" v-model="human_task_filter" />
              </div>
            </li>
          </ul>
          <p class="menu-label">{{ $t("human tasks") }}</p>
          <ul class="menu-list">
            <li
              v-for="(human_task, hidx) in filtered_human_tasks"
              :key="hidx"
              @click="edit_human_task(human_task)"
            >
              <a
                :class="{
                  'is-active': current_human_task_uuid == human_task.uuid,
                }"
                >{{ human_task.name }}</a
              >
            </li>
          </ul>
        </aside>
      </div>
      <div class="column" v-show="current_human_task_uuid">
        <human-task-editor ref="human_task_editor" @success="refresh" />
      </div>
    </div>
    <execute-modal ref="execute_modal" />
  </section>
</template>

<script>
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  post,
  get,
  input_alert,
  success_message,
  error_message,
  format_date,
  format_currency,
} from "@/utils";
// import StartEventModal from "./components/start_event/Index.vue";
import ConfigureModal from "./components/configure_modal/Index.vue";
import HumanTaskEditor from "./components/human_task_editor/Index.vue";
import ExecuteModal from "./components/execute_modal/Index.vue";

export default {
  name: "NgineComposerHumanTasks",
  components: { ConfigureModal, HumanTaskEditor, ExecuteModal },
  data() {
    return {
      human_tasks: [],
      current_human_task_uuid: null,
      human_task_filter: "",
    };
  },
  computed: {
    filtered_human_tasks() {
      let v = this;
      return v.human_tasks.filter((human_task) =>
        human_task.name
          .toLowerCase()
          .includes(v.human_task_filter.toLowerCase())
      );
    },
  },
  methods: {
    format_currency,
    new_human_task() {
      let v = this;
      input_alert({
        title: v.$t("new human task"),
        input_label: v.$t("enter the name of the human task"),
        input: "text",
        showCancelButton: true,
      })
        .then((value) => {
          post("/ngine/composer/human-task", {
            process_uuid: v.$route.params.id,
            name: value,
          })
            .then((response) => {
              // success_message(v.$t("human task created"));
              v.refresh();
            })
            .catch((error) => {
              error_message(error);
            });
        })
        .catch((error) => {
          error_message(error);
        });
    },
    refresh() {
      let v = this;
      v.$root.loader(true);
      get("/ngine/composer/human-task/all", { uuid: v.$route.params.id })
        .then((response) => {
          v.human_tasks = response;
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    edit_human_task(human_task) {
      let v = this;
      v.current_human_task_uuid = human_task.uuid;
      v.$refs.human_task_editor.edit(human_task.uuid);
    },
    save() {
      let v = this;
      v.$refs.human_task_editor.save();
    },
    remove() {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete human task?"),
        v,
        () => {
          del("/ngine/composer/human-task", { uuid: v.current_human_task_uuid })
            .then(() => {
              v.current_human_task_uuid = null;
              v.$refs.human_task_editor.clear();
              v.refresh();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    execute() {
      let v = this;
      let data = v.$refs.human_task_editor.get_data();
      v.$refs.execute_modal.show_modal(data);
    },
  },
  mounted() {
    let v = this;
    v.refresh();
  },
  created() {},
};
</script>

<style></style>
